import { useDayjsFormatter } from "@jmc/utils/hooks/useDayjsFormatter";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    code: string;
    date_of_preparation?: string;
}

export const IMR = ({ code, date_of_preparation = null }: Props): JSX.Element => {
    if (!code && !date_of_preparation) {
        return null;
    }
    const { t } = useTranslation();

    return (
        <>
            {t("{{iMR-code}} - {{iMR-date}}", {
                "iMR-code": code,
                "iMR-date": date_of_preparation ? useDayjsFormatter("MMMM YYYY", date_of_preparation) : "",
                ns: "common",
            })}
        </>
    );
};
